import { Injectable } from '@angular/core';

import {
  ACTION_NAMES,
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils';
import { adobeClickEventAnalyticsMocks } from '../../../mocks/utils';
import { AdobeDataLayerService } from './adobe-data-layer';

@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerServiceExtended extends AdobeDataLayerService {
  updateAnalyticsLoginModal(
    name: string,
    pageSection: string,
    button: boolean
  ): void {
    let data = adobeClickEventAnalyticsMocks;
    const buttonText = button ? ACTION_NAMES.BUTTON : ACTION_NAMES.LINK;
    const action = `${pageSection}:${name}:${buttonText}`;
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: action,
      click: {
        name: name,
        type: button ? EVENT_CLICK_TYPE.BUTTON : EVENT_CLICK_TYPE.LINK,
        page_section: pageSection,
        action: action
      },
      user: {
        attributes: {
          is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
          login_state: USER_LOGGED_IN_STATUS.COLD
        }
      }
    };
    this.analytics.setAnalytics(data);
  }
}
